<template>
  <!-- 预渲染使用 不要删除 app 的div-->
  <div id="app">
    <div :class="activityTimeFlag ? 'paddingBottom' : ''">
      <ai v-if="subject == 'ai'" />
      <java v-if="subject == 'java'" />
      <web v-if="subject == 'web'" />
      <architect v-if="subject == 'architect'" />
      <pythonData v-if="subject == 'py'" />
      <cPlus v-if="subject == 'cpp'" />
      <pm v-if="subject == 'pm'" />
      <dataAnalysis v-if="subject == 'dataAnalysis'" />
      <linux v-if="subject == 'linux'" />
      <media v-if="subject == 'media'" />
      <newMedia v-if="subject == 'newMedia'" />
      <newMedia2 v-if="subject == 'newMedia2'" />
      <test v-if="subject == 'test'" />
      <architect2 v-if="subject == 'architect2'" />
      <fcp v-if="subject === 'fcp'" />
      <acp v-if="subject === 'acp'" />
      <ai2 v-if="subject == 'ai2'" />
      <nau v-if="subject == 'nau'" />
      <mba v-if="subject == 'mba'" />
      <zero v-if="subject == 'zero'" />
      <design v-if="subject == 'design'" />
      <!-- <cbec v-if="subject == 'cbec'" /> -->
      <illinois v-if="subject == 'illinois'" />
      <stevens v-if="subject == 'stevens'" />
      <hawai v-if="subject == 'hawai'" />
      <harmony v-if="subject == 'harmony'" />
      <gra v-if="subject == 'gra'" />
      <inseec v-if="subject == 'inseec'" />
      <trainer v-if="subject == 'trainer'" />
      <agent v-if="subject == 'agent'" />
      <llm v-if="subject == 'llm'" />
      <aidrama v-if="subject == 'aidrama'" />
    </div>

    <img
      v-if="activityTimeFlag"
      class="img-bottom"
      src="./assets/img-bottom.jpg"
      alt=""
      @click="goToActivity"
    />
    <Error v-if="errorPage" />
  </div>
</template>

<script>
import ai from "../../../components/coursePage/ai/index.vue";
import java from "../../../components/coursePage/java/index.vue";
import web from "../../../components/coursePage/web/index.vue";
import architect from "../../../components/coursePage/architect/index.vue";
import pythonData from "../../../components/coursePage/pythonData/index.vue";
import pm from "../../../components/coursePage/pm/index.vue";
import dataAnalysis from "../../../components/coursePage/dataAnalysis/index.vue";
import cPlus from "../../../components/coursePage/cPlus/index.vue";
import linux from "../../../components/coursePage/linux/index.vue";
import media from "../../../components/coursePage/media/index.vue";
import newMedia from "../../../components/coursePage/newMedia/index.vue";
import newMedia2 from "../../../components/coursePage/newMedia2/index.vue";
import test from "../../../components/coursePage/test/index.vue";
import architect2 from "../../../components/coursePage/architect2/index.vue";
import fcp from "../../../components/coursePage/fcp/index.vue";
import acp from "../../../components/coursePage/acp/index.vue";
import ai2 from "../../../components/coursePage/ai2/index.vue";
import nau from "../../../components/coursePage/nau/index.vue";
import mba from "../../../components/coursePage/mba/index.vue";
import zero from "../../../components/coursePage/zero/index.vue";
import design from "../../../components/coursePage/design/index.vue";
// import cbec from "../../../components/coursePage/cbec/index.vue";
import illinois from "../../../components/coursePage/illinois/index.vue";
import stevens from "../../../components/coursePage/stevens/index.vue";
import hawai from "../../../components/coursePage/hawai/index.vue";
import harmony from "../../../components/coursePage/harmony/index.vue";
import Error from "../../../components/coursePage/common/404.vue";
import gra from "../../../components/coursePage/gra/index.vue";
import inseec from "../../../components/coursePage/inseec/index.vue";
import trainer from "../../../components/coursePage/trainer/index.vue";
import agent from "../../../components/coursePage/agent/index.vue";
import llm from "../../../components/coursePage/llm/index.vue";
import aidrama from "../../../components/coursePage/aidrama/index.vue";
import "../../../assets/font/font.css";
export default {
  name: "App",
  components: {
    ai,
    web,
    java,
    architect,
    pythonData,
    cPlus,
    pm,
    dataAnalysis,
    linux,
    media,
    newMedia,
    newMedia2,
    test,
    architect2,
    fcp,
    acp,
    ai2,
    nau,
    mba,
    zero,
    design,
    // cbec,
    illinois,
    stevens,
    hawai,
    harmony,
    Error,
    gra,
    inseec,
    trainer,
    agent,
    llm,
    aidrama
  },
  data() {
    return {
      activityTimeFlag: true,
      errorPage: false,
      subject: "",
      title: "",
      courseList: [
        "ai",
        "java",
        "web",
        "architect",
        "py",
        "cpp",
        "pm",
        "dataAnalysis",
        "test",
        "linux",
        "media",
        "newMedia",
        "newMedia2",
        "test",
        "architect2",
        "fcp",
        "acp",
        "ai2",
        "nau",
        "mba",
        "zero",
        "design",
        // "cbec",
        "illinois",
        "stevens",
        "hawai",
        "harmony",
        "Error",
        "gra",
        "inseec",
        "trainer",
        "agent",
        "llm",
        "aidrama"
      ],

      tdkList: [
        {
          name: "java",
          tdk: {
            title: "AI智能应用开发（Java）就业课- 黑马程序员线上品牌·博学谷",
            keywords:
              "Java+AI开发、SpringAI实战、大模型应用开发、智能体开发、Java微服务架构、企业级项目实战、AI辅助编程、Java学习路线、黑马程序员、博学谷",
            description:
              "聚焦Java与AI深度融合，课程覆盖SpringAI、大模型微调、RAG检索增强等前沿技术，结合企业级智能物联⽹项⽬、互联⽹分布式微服务等真实企业级项目，打造“Java核心+AI创新”复合竞争力。零基础到中高级工程师全链路培养，对标中大厂岗位需求，提供AI辅助开发、简历优化、面试突击等就业服务，助你快速进阶AI时代的Java中高级工程师。"
          }
        },
        {
          name: "web",
          tdk: {
            title: "HTML&JS+前端-就业课-黑马程序员线上品牌-博学谷",
            keywords: "HTML&JS+前端,企业级前端项目研究院,全球开源项目,学习路线图",
            description:
              "放眼所见皆为前端，牛师带队，高质量教研师资。小程序+Vue3+React三大技术点，深入浅出带你透彻掌握前端技术，100+ 案例巩固和运用技术点，N个线上学员专属公开课。多行业真项目，接轨企业需求，覆盖电商、新闻、医疗等6大领域，拿来即用，从入门到就业，通过博学谷成功转行、就业。"
          }
        },
        {
          name: "ai",
          tdk: {
            title: "人工智能开发-AI就业课-黑马程序员线上品牌-博学谷",
            keywords: "人工智能,高级软件工程师课程,Python编程,NLP,CV",
            description:
              "选择AI，0基础课程带你轻松入行。博学谷，重点培养AI两大关键能力，覆盖AI职业完整技能，6个月助力学员高端就业。与大厂共建资源库，培育出市场真正需要的AI人才。多领域多行业项目、打造AI核心竞争力，帮你积累1-3年业务经验。社会主流热点随时更新，学完胜任企业工作。"
          }
        },

        {
          name: "architect",
          tdk: {
            title: "狂野架构师-职场进阶课-黑马程序员线上品牌-博学谷",
            keywords: "Java架构师,狂野架构师,分布式系统,Java工程师,Java进阶",
            description:
              " 在博学谷，突破职业瓶颈，成为Java架构师需要6个月，因为课程内容精，所以学习速度快。该多则多，夯实核心技术，该精必精，拒绝低效内卷，7大实战项目，涉及打车、餐饮、通信、电商、房产等多个热门领域，直面企业各种开发需求。博学谷老师各环节无缝对接，提供高质量、专业化辅导。"
          }
        },
        {
          name: "py",
          tdk: {
            title: "Python+大数据-就业课-黑马程序员线上品牌-博学谷",
            keywords: "Python+大数据开发,0基础,Apache贡献者,主流解决方案",
            description:
              "从入门到就业，打造实力派数据工程师，Apache贡献者、985计算机硕士领衔授课，课程与时俱进，不断融入热门技术，采用必修+拓展模式授课，高效就业、灵活提升，高标准企业级项目，还原真实开发流程，在博学谷学习后，成功进入Python+大数据开发领域。"
          }
        },
        {
          name: "cpp",
          tdk: {
            title: "C/C++-就业课-黑马程序员线上品牌-博学谷",
            keywords: "C/C++,服务器开发,底层应用,Go语言",
            description:
              "博学谷C/C++，更深入/更底层/更细节/更多企业级重磅项目，远超同类培训课程。更扎实的基础知识+更全面的进阶技能，助你职位发展先人一步，5大企业级重磅项目支撑实战经验拿来即用，课程内容更深入，项目实战更硬核，学习服务更全面，高薪就业自然更轻松。"
          }
        },
        {
          name: "pm",
          tdk: {
            title: "AI 产品经理-就业课-黑马程序员线上品牌-博学谷",
            keywords: "产品经理,AI 产品经理,用户需求,产品设计,AI 产品",
            description:
              "实战项目+AI，AI 产品经理必经之路，包括内容产品、电商产品+运营、B端等实践项目，同时涉及 AI 产品经理，包括提示词工程、AI 大模型 API 接入、智能体设计等核心阶段内容，可以胜任一线企业实际工作需求。"
          }
        },
        {
          name: "dataAnalysis",
          tdk: {
            title: "数据开发-就业课-黑马程序员线上品牌-博学谷",
            keywords: "中高级数据分析师,机器学习,数据挖掘",
            description:
              "课程内容主打数据挖掘、机器学习等热点领域，直指高薪岗位！技能+思维+实战，系统性学习才能具备真正数据分析能力。3大企业级项目、20+实战案例，项目经验拿来即用，专职课程研发团队，严控课程质量,高学历、实力派教研团队，学习效果更有保障！"
          }
        },
        {
          name: "test",
          tdk: {
            title: "AI测试-就业课-AI测试全栈工程师培养 | 黑马程序员线上品牌-博学谷",
            keywords: "AI测试, 大模型测试, 鸿蒙AI测试, 自动化测试, 接口测试, 性能测试, RAG测试, AI测试工程师培训, 软件测试转行, 大模型微调, Python自动化, 智能体测试",
            description:
              "零基础学AI测试，掌握AI手工测试、大模型幻觉识别与RAG专项测试、Python自动化测试、接口与性能测试、鸿蒙AI测试等全栈技能，系统培养AI时代稀缺的测试人才，并通过金融、电商等8大行业真实项目实战，构建“AI+测试”工程化思维，实现效率倍增，成为企业争抢的复合型人才。"
          }
        },
        {
          name: "linux",
          tdk: {
            title: "AI运维-就业课-黑马程序员线上品牌-博学谷",
            keywords:
              "Linux操作系统，运维,运维工程师,运维培训，Linux培训，AI运维线上课程，黑马程序员AI运维，博学谷AI运维，AI运维就业班，数据库运维，自动化运维，容器运维，云计算，云安全，运维工程师，AIOps，大数据运维，国产信创",
            description:
              "AI运维课程以阿里云平台为依托，聚焦国产操作系统，覆盖多领域高阶项目矩阵、依托50+企业级仿真场景、深度融合AI大模型技术。与招聘平台岗位需求匹配度超90%，助你快速成为市场紧缺的智能运维人才，无缝对接高薪岗位。从入门到就业，打造实力派运维工程师，实力派讲师天团领衔授课，课程与时俱进，不断融入热门技术，采用必修+拓展模式授课，高效就业、灵活提升。博学谷就业服务保障体系，力争每位毕业学生高薪就业。"
          }
        },
        {
          name: "media",
          tdk: {
            title: "短视频-就业课-黑马程序员线上品牌-博学谷",
            keywords: "抖音新玩法,短视频课程,涨粉技巧",
            description:
              "短视频掘金流量陪跑训练营，精细化”实战陪跑，针对不同程度学员制定专属学习计划，7至10年专业运营师全程陪跑，百万粉丝大V参与课研，每周实时更新抖音新玩法。告别独自盲目摸索阶段，行业大牛带你狂飙！"
          }
        },
        {
          name: "newMedia",
          tdk: {
            title: "新媒体+短视频-就业课-黑马程序员线上品牌-博学谷",
            keywords: "新媒体+短视频直播运营,账号定位,内容运营,用户运营,数据运营,渠道运营",
            description:
              "培养行业热门岗位（短视频/直播/社群运营）精准发力，靶向施策，就业率远超其他竞品，百万粉丝大V参与课研。课程优势突出，对标企业需求，聚焦培养新媒体运营+社群运营+短视频运营+电商直播运营。延伸拓展收获更多硬技能。"
          }
        },
        {
          name: "newMedia2",
          tdk: {
            title: "IP短视频带货-超级副业-传智-黑马程序员线上品牌-博学谷",
            keywords: "IP短视频带货,推荐,搜索,付费,流量密码,账号运营,180天1对1服务",
            description:
              "对标抖音账号新玩法，精准解锁 推荐、搜索、付费三大流量密码，实现IP视频带货，成就你的超级副业！180天全方位、精细化、高标准陪跑，百万粉丝大V7至10年行业大牛亲自带队，课程内容高度凝练，快速讲透账号运营全体系，助力打造高流量短视频IP带货账号！"
          }
        },
        {
          name: "test",
          tdk: {
            title: "软件测试-就业课-黑马程序员线上品牌-博学谷",
            keywords: "软件测试,接口测试,性能测试,自动化测试,懂编程",
            description:
              "由于市场招聘需求驱动，具备自动化、性能测试、接口测试等中高级技能的岗位薪资相对更为可观。在这里，4个月课程将重点教会你自动化测试等高阶技能。拥有多个完整真实的大型项目，覆盖电商、新闻、智能物联网、人工智能等热门行业，使学员在学习的过程中如同浸泡在真实企业开发环境中。"
          }
        },
        {
          name: "ui",
          tdk: {
            title: "全链路UI设计-就业课-黑马程序员线上品牌-博学谷",
            keywords: "UI/UE设计师,电商设计师,视觉设计师,WEB设计师,品牌设计师,交互设计师",
            description:
              "零基础全链路UI设计，全新模式，全方位贴合企业用人需求。注重设计思维及理念，不断打磨升级企业需要的高精尖全链路UI设计人才具备的知识技能。6大热门职业量身定制，紧跟行业发展，课程内容1：1对标企业需求。30+项目案例，与企业接轨，让你毕业即就业。"
          }
        },
        {
          name: "python",
          tdk: {
            title: "Python开发-就业课-黑马程序员线上品牌-博学谷",
            keywords: "Python开发学习,就业热点技术,就业强化课,Python开发工程师",
            description:
              "一站式开发模式，打造全能型Python开发工程师，包含两大核心知识体系，专注于Python热门就业方向，大型企业级综合实战项目，课程满足多群体学习需求，职业发展路径明确，教学服务再升级，学习无后顾之忧。"
          }
        },
        {
          name: "architect2",
          tdk: {
            title: "Java工程师进阶课程-企业级核心框架-源码剖析-博学谷",
            keywords: "Java进阶,转型架构师,框架搭建,框架底层原理,大规模企业开发",
            description:
              "50小时，搞定企业级核心框架。学完掌握项目内的开发框架，轻松完成组件开发；掌握Web框架的系统化功能定制；掌握高性能网络通信，适用于物联网、各类终端、Web服务器等；掌握框架底层原理和源码；熟知微服务体系的高级功能定制；拥有懂业务、会架构、精技术、高交付的能力。"
          }
        },
        {
          name: "fcp",
          tdk: {
            title: "帆软FCP认证&培训-传智-黑马程序员线上品牌-博学谷",
            keywords: "帆软FCP认证考试,报表交付工程师,培训学习,大数据热门技术,企业数据管理",
            description:
              "帆软FCP认证，符合当前招聘需求，迎合市场行情。认证成功后可以获得行业权威认可、获取更高薪酬。合理的学习路径才是通过认证的唯一标准：系统性自学，2个月平稳掌握；报名《FCP报表交付工程师认证·精讲课》，18小时快速精通。课程融入传智教育自主研发大数据热门内容，即使不用来考证，也可以学到前沿核心技术用于工作中。"
          }
        },
        {
          name: "acp",
          tdk: {
            title: "阿里云大数据ACP认证课-传智-黑马程序员线上品牌-博学谷",
            keywords: "阿里云ACP认证考试,大数据工程师,培训课,技术流,云资源,离线,实时",
            description:
              "传智大数据技术专家基于阿里云认证标准深入研发课程，完整的课程体系，详细专业的学习路线，理论&实操&技术&证书一课搞定。课程包含电商仪表板绘制、阿里云ECS项目实战等5大真实业务场景案例，以动手实操形式串联大纲，助力快速掌握考试要点。"
          }
        },
        {
          name: "ai2",
          tdk: {
            title: "AI大模型训练营-传智-黑马程序员线上品牌-博学谷",
            keywords: "AI大模型,人工智能,培训课,算法工程师,文生图,大模型,AI",
            description:
              "传智教育紧跟技术发展及市场需求，推出AI大模型训练营课程，让你8周掌握大模型垂直业务领域应用与开发能力。内容涵盖【大模型入门】、【大模型应用初体验】、【大模型初级开发】、【大模型高级开发】四个阶段，学后可独立运用大模型技术开发文生图、情感分析、知识问答等项目。"
          }
        },
        {
          name: "nau",
          tdk: {
            title: "美国北亚利桑那大学",
            keywords: "计算机硕士,北亚利桑那大学,美国计算机硕士",
            description:
              "美国百年公立旗舰大学北亚利桑那大学-计算机信息技术硕士,免联考,免GRE/托福/雅思,中文授课,无需出国,现可国内在职读,全日制计算机硕士学位。"
          }
        },
        {
          name: "mba",
          tdk: {
            title: "美国金门大学",
            keywords: "工商管理硕士,北亚利桑那大学",
            description:
              "全美最受欢迎的商学研究院之一金门大学,无需参加联考或者研究生考试,专本可读，不授学历限制在职可读，不授地域和时间限制。"
          }
        },
        {
          name: "zero",
          tdk: {
            title: "程序设计入门指南-传智-黑马程序员线上品牌-博学谷",
            keywords: "传智杯大赛，程序设计赛道，算法知识",
            description:
              "详细介绍参加传智杯大赛能带来收益，重点介绍程序设计赛道相关内容，详细讲解算法相关基础知识，为参加大赛打下坚实的基础"
          }
        },
        {
          name: "design",
          tdk: {
            title: "程序设计入门指南-传智-黑马程序员线上品牌-博学谷",
            keywords: "传智杯大赛，程序设计赛道，算法知识",
            description:
              "详细介绍参加传智杯大赛能带来收益，重点介绍程序设计赛道相关内容，详细讲解算法相关基础知识，为参加大赛打下坚实的基础"
          }
        },
        // {
        //   name: "cbec",
        //   tdk: {
        //     title: "跨境电商培训_跨境电商培训课程_TikTok培训-黑马程序员",
        //     keywords: "跨境电商培训,tiktok培训,跨境电商运营培训,tiktok店铺培训,tiktok跨境电商培训,跨境电商培训班",
        //     description:
        //       "黑马程序员跨境电商培训班官网,专注跨境电商培训，tiktok 跨境电商培训，提供tiktok培训、跨境电商运营培训、tiktok运营培训、tiktok店铺运营培训、tiktok带货培训等服务，力争培养具有跨境电商运营，tiktok店铺运营的人才，学跨境电商就选黑马程序员！"
        //   }
        // },
        {
          name: "illinois",
          tdk: {
            title: "伊利诺伊理工大学MBA | 在线国际硕士项目",
            keywords:
              "伊利诺伊理工大学MBA排名、伊利诺伊理工大学MBA申请要求、伊利诺伊理工大学硕士学费",
            description: "伊利诺伊理工大学MBA，全球500强认可，高性价比在线硕士。"
          }
        },
        {
          name: "stevens",
          tdk: {
            title: "史蒂文斯理工计算机硕士 | 在线国际硕士项目",
            keywords:
              "史蒂文斯理工学院计算机科学硕士申请条件、史蒂文斯理工学院数据科学硕士学费、史蒂文斯理工学院硕士排名",
            description: "史蒂文斯理工计算机硕士，全球顶尖课程，助力科技职业发展。"
          }
        },
        {
          name: "hawai",
          tdk: {
            title: "夏威夷太平洋大学AI硕士 | 在线国际硕士项目",
            keywords:
              "夏威夷太平洋大学MBA学费、夏威夷太平洋大学人工智能硕士申请条件、夏威夷太平洋大学在线硕士项目",
            description: "夏威夷太平洋大学AI硕士，培养人工智能高端人才，快速获得国际学历。"
          }
        },
        {
          name: "harmony",
          tdk: {
            title: "鸿蒙应用开发培训-博学谷在线就业课 | 黑马程序员线上品牌",
            keywords:
              "鸿蒙开发培训，鸿蒙线上课程，鸿蒙工程师培训，鸿蒙就业班，鸿蒙项目实战，博学谷鸿蒙培训，黑马程序员鸿蒙课程，鸿蒙应用开发培训，HarmonyOS应用开发培训，华为鸿蒙应用开发培训，（纯血）鸿蒙线上培训，纯血鸿蒙培训，纯血鸿蒙课程，华为纯血鸿蒙培训",
            description:
              "博学谷（传智教育旗下在线IT教育平台）提供专业的鸿蒙应用开发线上培训课程，涵盖“纯血”鸿蒙应用开发核心技术、Flutter、uni-app跨平台开发框架、8大实战项目和就业指导。课程基于HarmonyOS 5.0 （NEXT）版本 ，并结合华为大获奖项目和真实上架项目进行研发，助力学员掌握纯血鸿蒙开发和跨平台开发技能，用真实力提升职业竞争力，从入学到就业一路护航！"
          }
        },
        {
          name: "gra",
          tdk: {
            title:
              "大学生毕业设计早鸟活动_全流程指导 | 选题开题/项目设计/研发制作/代码讲解/部署答疑-博学谷",
            keywords:
              "早鸟折扣、优惠报名、毕业设计、毕设、开题报告、毕设论文、毕设项目、辅导答辩、项目开发、安装部署",
            description:
              "参加毕设早鸟活动，专享报名优惠福利！博学谷大学生毕业设计辅导！提供选题开题、项目设计、开发制作、代码讲解、部署答疑、售后辅导、论文指导参考等服务。参与活动，顺畅解决毕设难题，助力顺利毕业！"
          }
        },
        {
          name: "inseec",
          tdk: {
            title: "法国 INSEEC 高商 MBA | 在线国际硕士项目",
            keywords:
              "法国 INSEEC 高商 MBA、免考 MBA、国际工商管理硕士、在职 MBA、在职研究生、法国商学院硕士、传智教育国际学历",
            description:
              "传智教育合作法国 INSEEC 高等商学院 MBA 项目：免考申请入学，全中文授课，在职可读，获法国正规硕士学位，助力职场晋升。高性价比国际学历，适配企业管理 / 职场进阶人群。"
          }
        },
         {
          name: "trainer",
          tdk: {
            title: "AI训练师在线课程｜掌握AI落地“最后一公里”，零基础入门直通高薪岗位",
            keywords:
              "AI训练师, 人工智能训练师课程, AI模型评测, AI测试质检, 大模型落地, AI人才培养, AI职业转型, AI实战课程, AI就业, AI+行业",
            description:
              "系统掌握AI模型评测、测试质检与喂养调教，全流程实战打造可直接上手的一线AI训练师能力，助你抓住人才紧缺高薪风口，成为企业争抢的“AI+行业”核心人才"
          }
        },
        {
          name: "agent",
          tdk: {
            title: "AI智能体开发·训练营｜转战AI开发 稳占高薪阵地",
            keywords:
              "AI智能体开发训练营,大模型部署实战,云算力优化,零基础AI转岗,智能体架构设计,LLM模型微调,AI工程师高薪,云主机部署,AIGC开发落地,AI实战课程",
            description:
              "AI智能体开发实战训练营，系统掌握大模型运行、架构设计与应用落地全流程。学会低成本云端优化部署、模型微调实战，快速构建生产级AI智能体，助力转岗AI开发高薪岗位，实战驱动高效上手核心技能"
          }
        },
        {
          name: "llm",
          tdk: {
            title: "AI大模型开发-就业课-挑战年薪30万-博学谷-黑马程序员线上品牌",
            keywords:
              "AI大模型培训、大模型实战课程、零基础学AI、AI开发工程师、智能体开发、RAG技术、大模型微调、多模态开发、大厂技术、AI行业就业",
            description:
              "零基础学AI大模型开发，对标企业真实岗位需求，覆盖智能体、RAG、微调、多模态四大热门AI技术，从算法原理、代码实操到项目开发上线全链路实战教学，学完可直接落地，10+企业级项目实战，接轨电商、金融、教育、医疗等6大热门行业，求职竞争力拉满。腾讯云/阿里云/科大讯飞大厂共建，双师全程陪跑，实现从学习到就业的无缝衔接。立即免费试学！"
          }
        },
        {
          name: "aidrama",
          tdk: {
            title: "AI漫剧实战特训营-0基础学AI漫剧制作 | 黑马程序员线上品牌-博学谷",
            keywords:
              "AI漫剧制作, AI短剧, 0基础学AI漫剧, AI动画制作, AI剧本生成, AI分镜设计, AI视频剪辑, 漫剧运营, AIGC实战课程，AI短剧教程，AI赚钱技能, 漫剧就业",
            description:
              "专为0基础小白打造的AI漫剧实战课！覆盖AI剧本创意、AI分镜绘制、AI视频生成与剪辑运营全链路。课程对接行业真实商单，学习期间即可接单变现，助你掌握AI赚钱技能，开启内容创作新赛道。"
          }
        }
      ],
      subjectTdk: {
        name: "",
        tdk: {
          title: "",
          keywords: "",
          description: ""
        }
      }
    };
  },
  created() {
    this.subject = this.getQueryString("subject") || null;
    this.getNowTdk();
    this.bottomShow();
  },
  mounted() {
    window.addEventListener("scroll", function() {
      window.parent.postMessage({ type: "scroll" }, "*");
    });
    this.subject = this.getQueryString("subject") || null;

    if (this.IsPC() && this.subject) {
      window.location.href = `${process.env.VUE_APP_BASE_onlineUrl}/coursePage/?subject=${this.subject}&pageType=0`;
    }
    const pageName = this.subjectTdk.tdk.title.replace(/-黑马程序员线上品牌-博学谷|-博学谷/g, "");
    zhuge.track("进入_专题页", {
      终端: "H5",
      专题页名称: pageName
    });
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.courseList.indexOf(this.subject) == -1) {
          this.errorPage = true;
        }
      }, 200);
    });
  },

  methods: {
    bottomShow() {
      let start = new Date("2023/10/16 10:00:00");
      let end = new Date("2023/10/31 23:59:59");
      if (new Date().getTime() < start.getTime()) {
        this.activityTimeFlag = false;
      } else if (new Date().getTime() > end.getTime()) {
        this.activityTimeFlag = false;
      } else {
        this.activityTimeFlag = true;
      }
    },
    goToActivity() {
      let base_path = "";
      if (
        window.location.origin == "https://www.boxuegu.com" ||
        window.location.origin == "https://m.boxuegu.com"
      ) {
        base_path = "https://www.boxuegu.com/subject";
      } else {
        base_path = "https://portal-ysc.boxuegu.com/subject";
      }
      window.location.href = base_path + "/activity-42.html" + window.location.search;
    },
    getNowTdk() {
      let tdkIndex = this.tdkList.findIndex(item => item.name == this.subject);
      if (tdkIndex !== -1) this.subjectTdk = this.tdkList[tdkIndex];
    },
    getQueryString(key) {
      var url = window.location.search;
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      var result = url.substr(1).match(reg);
      return result ? decodeURIComponent(result[2]) : null;
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  metaInfo() {
    return {
      title: this.subjectTdk.tdk.title,
      meta: [
        {
          name: "keywords",
          content: this.subjectTdk.tdk.keywords
        },
        {
          name: "description",
          content: this.subjectTdk.tdk.description
        }
      ]
    };
  }
};
</script>

<style lang="scss">
// * {
//   -webkit-touch-callout: none; /*系统默认菜单被禁用*/
//   -webkit-user-select: none; /*webkit浏览器*/
//   -khtml-user-select: none; /*早起浏览器*/
//   -moz-user-select: none; /*火狐浏览器*/
//   -ms-user-select: none; /*IE浏览器*/
//   user-select: none; /*用户是否能够选中文本*/
// }
input {
  outline: none;
}
body,
html {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 10px;
}
ul,
p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
i,
div {
  margin: 0;
  padding: 0;
  list-style: none;
  font-style: normal;
  // font-family: none;
}

#chatBtn {
  visibility: hidden;
}
.img-bottom {
  width: 100%;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
}
.paddingBottom {
  padding-bottom: 88px;
}
</style>
